"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var wrapper_1 = __importDefault(require("../../view/wrapper"));
exports["default"] = (function (props) {
    var data = props.data;
    return data.map(function (d, i) { return (react_1["default"].createElement(wrapper_1["default"], { key: i, label: d.label },
        react_1["default"].createElement(core_1.Typography, null, d.value))); });
});
